import { Year } from '../types/year'
import { http } from '../services/http'
export const fetchYears = async (): Promise<Array<Year>> => {
  const response = await http.get<Array<Year>>('/v2/years')
  return response.data
}
